/* eslint-disable */

// Users
import Users from "@/views/Users.vue";
import usersIndex from "@/components/users/Index.vue";
import usersAdd from "@/components/users/Add.vue";

//Middleware
import isLogin from "@/middleware/AuthMiddleware.js";

export default 
{
  path: "/users",
  component: Users,
  children:[
    {
      path:'/',
      name: "users",
      component:usersIndex,
      meta:{
        parent: "users",
        title: "Users",
        navbar:true,
        middleware:[
          isLogin,
        ]
      },
    },
    {
      path:'add',
      component:usersAdd,
      name: 'users.add',
      meta:{
        parent: "users",
        title: "Tambah User",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    },
    {
      path:'edit/:id',
      component:usersAdd,
      name:"users.edit",
      meta:{
        parent:"users",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    }
  ]
}